<template>
    <div>
        <div class="block">
            <div class="pagination">
                <p class="pagesizes">
                   <!-- <select name="" v-model="pageSize" @change="setConfig">
                        <option v-for="item in sizes" :value="item.value" :key="item.value">{{item.value}}</option>
                    </select> -->
                    <el-select v-model="pageSize" placeholder="请选择" class="pageSelect">
                        <el-option
                          v-for="item in sizes"
                          :key="item.value"
                          :label="item.value"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    条/页
                </p>
                <span class="first" @click="toFirst">首页</span>
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="pageNumber"
                    :page-size="pageSize"
                    layout="prev, pager, next"
                    :total="pageTotal" background>
                </el-pagination>
                <span class="last" @click="toLast">尾页</span>
                <span class="jumper">
                    跳转至<input type="text" class="page-number" @keyup="inputChange" v-model="number" @keyup.enter="setNum" @blur="setNum">页
                </span>
                <span style="position: absolute; right: 15px;margin-top: 3px;font-size: 15px;">共 {{total}} 条</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            pageNumber:1,
            pageSize:10,
            pageTotal:0,
            total:0,
            maxPage:1,
            size:1,  //组类型
            sizes: [
                {value: 10},
                {value: 30},
                {value: 50},
                {value: 100},
            ],
            number:1,
            oldNum:0,
            isTrue:true,
            noset:true,
        }
    },
    props:{
        totalCount:{
            type: Number,
            required: true
        },
        setNumber:{
            type: Number,
            required: true
        }
    },
    created() {
        this.setMaxPage();
        this.pageSize = this.$store.state.userConfig.rowsPerPage
    },
    methods: {
        handleCurrentChange(val) {
            this.pageNumber=val
        },
        inputChange() { //输入框值改变
                let type = typeof this.number;
                if(this.number == ""){
                    return
                }
                if(type == 'number' ){
                    return
                }
                this.number = this.number.replace(/[^\d]/g, '');
                this.number = Number(this.number)
        },
        setNum(){
            if(this.number > this.maxPage && this.number){
                this.number = this.maxPage;
            }else if (this.number <= 0 ){
                this.number = 1
            }
            this.pageNumber=this.number
        },
        setMaxPage(){
            if(this.pageTotal ==0){
                this.total=0
                return
            }
            let total = this.pageTotal;
            let size = this.pageSize;
            this.setConfig()
            this.maxPage = total%size==0?(total/size):(Math.floor(total/size)+1);
            if(this.maxPage  < this.pageNumber){
                this.pageNumber = this.maxPage
            }
        },
        toFirst(){
            this.pageNumber = 1
        },
        toLast(){
            this.pageNumber = this.maxPage
        },
        setConfig(val){
            if(this.noset) {
              this.noset = false
              return
            }
            if(this.pageSize == this.$store.state.userConfig.rowsPerPage){ return }
            let pageObj={
                size:this.pageSize,
                number:this.pageNumber
            }
            this.$emit("setSize",pageObj)
            this.postNoJson('/UserConfig/set',{name:'rowsPerPage',value:this.pageSize}).then((res)=>{
                if(res.success){
                    this.$store.state.userConfig.rowsPerPage=this.pageSize
                    localStorage.setItem('rowsPerPage',this.pageSize)
                }
            })
        }
    },
    watch: {
        //监听大小
        pageSize(){
            this.setMaxPage();
        },
        // 监听页数
        pageNumber(){
            if(this.pageNumber==0){
                return
            }
            this.number = this.pageNumber
            this.oldNum = this.number;
            this.$emit('setNum', this.number==0?1:this.number)
        },
        // 总数改变更新页数
        totalCount(){
            this.pageTotal=this.totalCount
            this.total = this.pageTotal
            this.setMaxPage()
        },
        //修改当前页
        setNumber(){
            this.pageNumber=this.setNumber
        }
    },
}
</script>
<style scoped>
    .pagination{
        /* position: absolute;
        bottom: 35px; */
        width: 90%;
        padding: 0 16px;
        font-size: 14px !important;
    }
    .pagesizes{
        float: left;
        font-size: 14px;
    }
    .jumper{
        font-size: 15px;
        position: relative;
        top: 2px;
    }
    .pagesizes select{
        /*很关键：将默认的select选择框样式清除*/
        appearance:none;
        -moz-appearance:none;
        -webkit-appearance:none;
        width: 65px;
        border: 1px solid #d2d2d2;
        background: url("@../../../../assets/image/organize/down.png") no-repeat scroll right center transparent;
        padding-right: 14px;
        background-size: 20px;
        height: 22px;
        padding:0 5px;
        box-sizing: border-box;
    }
    .pagesizes select::-ms-expand { display: none; }
    .page-number{
        width: 45px;
        line-height: 20px;
        padding: 0 5px;
        border: 1px solid #d2d2d2;
        margin: 0 5px;
    }
    .first,.last{
        cursor:pointer;
        font-size: 14px;
        position: relative;
        top: 2px;
    }
    .last{
        margin-right:5px;
    }
    .pageSelect{
      width: 75px;
    }
</style>
<!-- 修改ele-ui 默认样式 -->
<style>
    .el-pagination{
        font-weight: 500;
        display: inline-block;
        /* margin-left: -57px; */
    }
    .el-pager .number{
        height: 22px !important;
        line-height: 22px !important;
        width: 22px;
        min-width: 22px !important;
        padding: 0 !important;
    }
    button.btn-prev,button.btn-next,li.more{
        height: 22px !important;
        line-height: 22px !important;
        width: 22px;
        min-width: 22px !important;
        padding: 0 !important;
    }
    .el-select.pageSelect .el-input__inner,.el-select.pageSelect .el-select__caret{
      height: 26px !important;
      line-height: 26px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/pagination.vue